var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 252,
    viewBox: "0 0 232 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5891 85.3383C76.3662 78.4403 56.3414 83.6768 49.0024 91.5312C41.6633 99.3855 40.0242 116.028 38.6817 126.743C37.1633 139.256 38.9879 151.257 40.1766 163.82C44.8514 187.058 50.763 193.349 57.3334 204.106C63.8776 214.786 74.9174 223.349 87.3631 224.481C99.8088 225.614 107.088 219.027 110.299 206.903C114.569 214.692 126.036 223.645 134.886 223.635C152.313 223.615 156.583 211.347 160.694 203.444C168.436 208.648 172.726 208.657 177.126 208.834C181.525 209.011 185.787 206.973 189.291 204.232C202.609 194.025 202.292 178.089 203.796 161.405C205.423 142.505 202.505 128.608 198.588 110.001C195.941 97.2321 190.539 85.1472 182.201 75.0693C173.863 64.9914 160.799 58.1511 147.869 60.2252C135.045 62.3513 122.362 65.6254 124.931 78.4208C124.381 69.8197 118.106 61.7465 109.872 59.2015C101.638 56.6566 91.9658 59.6393 86.6012 66.3965C81.2365 73.1538 79.7998 77.8108 84.5891 85.3383Z",
    fill: "url(#paint0_linear_336_53037)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5271 92.6771C50.8649 84.8231 76.3613 78.4301 84.5846 85.3294C79.7947 77.8009 81.2309 73.1438 86.5944 66.3868C91.958 59.6297 101.63 56.6479 109.863 59.1939C117.3 61.4936 123.14 68.3036 124.606 75.9385C124.377 71.2791 126.465 68.0791 129.879 65.7875C125.432 71.8055 124.512 76.3201 128.959 83.3098C120.736 76.4105 100.713 81.6451 93.3751 89.499C86.4767 96.8827 84.6166 112.035 83.3042 122.726C83.2206 123.407 83.1392 124.07 83.0589 124.711C84.3708 137.38 86.315 148.239 88.8193 160.014C89.1704 161.143 89.5112 162.241 89.8432 163.311C94.7364 179.079 97.7193 188.691 103.873 198.767C110.418 209.447 121.458 218.012 133.903 219.146C146.348 220.28 151.471 217.007 154.681 204.883C155.462 206.307 156.483 207.771 157.686 209.211C153.833 216.11 148.06 223.576 135.083 226.323C126.234 226.332 116.467 223.58 112.197 215.79C108.987 227.915 101.709 234.501 89.2639 233.367C76.8188 232.233 65.7786 223.669 59.2337 212.988C52.6624 202.229 50.5079 197.071 40.8784 171.961C36.6737 158.919 34.1813 145.515 33.2109 127.889C32.2404 110.263 36.1893 100.531 43.5271 92.6771Z",
    fill: "url(#paint1_linear_336_53037)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.131 140.398C147.424 101.456 133.39 88.5702 127.336 86.9948C107.337 60.8708 146.557 44.9776 177.345 64.9755C199.323 79.2512 210.962 112.146 211.172 158.532C211.382 204.919 186.694 216.576 173.633 213.984C163.184 211.911 160.287 206.691 160.144 204.34C161.684 199.252 162.837 179.34 155.131 140.398Z",
    fill: "url(#paint2_linear_336_53037)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8119 91.0114C77.697 77.2307 78.9647 61.2554 85.8848 48.2754C92.7078 35.2307 104.94 25.2297 118.921 20.5985C123.262 19.1462 128.122 18.1794 132.414 19.8479C136.706 21.5164 139.993 26.58 138.145 30.8154C126.742 29.8049 115.401 39.2081 114.296 50.5266C113.208 61.9259 122.47 73.2839 133.825 74.4722C129.368 83.767 120.991 91.151 111.174 94.2813C101.438 97.3954 90.3589 96.3205 82.8119 91.0114Z",
    fill: "#46A493"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8119 91.0114C77.697 77.2307 78.9647 61.2554 85.8848 48.2754C92.7078 35.2307 104.94 25.2297 118.921 20.5985C123.262 19.1462 128.122 18.1794 132.414 19.8479C136.706 21.5164 139.993 26.58 138.145 30.8154C126.742 29.8049 115.401 39.2081 114.296 50.5266C113.208 61.9259 122.47 73.2839 133.825 74.4722C129.368 83.767 120.991 91.1511 111.174 94.2813C101.438 97.3954 90.3589 96.3205 82.8119 91.0114Z",
    fill: "url(#paint3_linear_336_53037)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.28 22.5544C138.349 24.8573 139.368 28.0152 138.148 30.8121C126.744 29.8021 115.402 39.2056 114.297 50.5238C113.208 61.9228 122.47 73.2801 133.825 74.4679C130.107 82.2201 123.663 88.6432 115.931 92.378C115.241 91.3629 114.38 90.3689 113.26 89.4559C101.467 85.745 95.3113 65.6379 101.346 52.1526C107.288 38.5965 118.306 28.3925 131.083 23.8918C132.752 23.2975 134.508 22.7963 136.28 22.5544Z",
    fill: "url(#paint4_linear_336_53037)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.002 19.9583C106.835 24.7174 80.2825 49.4421 85.2692 74.3728C87.1941 83.9962 90.7951 90.7847 94.4386 95.5682C90.1536 94.8703 86.1376 93.3526 82.8088 91.011C77.6942 77.231 78.9626 61.2559 85.8835 48.276C92.7072 35.2314 104.94 25.2302 118.921 20.5985C119.603 20.3704 120.298 20.1542 121.002 19.9583Z",
    fill: "url(#paint5_linear_336_53037)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.52 141.679C167.941 229.347 150.841 220.271 104.655 205.589C83.3368 190.817 69.9715 126.666 76.1794 102.708C78.8892 92.2502 101.862 82.4955 118.375 84.3585C146.964 92.425 153.008 122.165 158.52 141.679Z",
    fill: "url(#paint6_linear_336_53037)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7241 204.422C56.0808 206.995 57.5258 209.478 59.2885 212.364C65.8346 223.047 76.8753 231.614 89.3196 232.75C101.764 233.886 109.04 227.301 112.248 215.176C116.519 222.967 126.285 225.72 135.134 225.712C142.335 224.189 147.316 221.212 150.983 217.685C155.138 214.111 157.512 209.324 159.564 205.186L159.564 205.186C159.785 204.741 160.001 204.305 160.216 203.878C160.474 206.296 163.468 211.338 173.689 213.369C184.034 215.424 201.671 208.539 208.445 182.526C197.002 192.059 183.714 194.224 175.159 192.467C164.597 190.297 160.779 186.243 159.853 183.564C155.627 194.932 147.325 202.485 127.767 204.931C116.693 204.478 109.581 202.841 92.7892 191.286C87.0969 203.284 82.3242 209.311 66.909 207.523C62.6079 207.025 58.5236 205.951 54.7241 204.422ZM96.8349 182.193C96.9237 182.28 97.0128 182.367 97.1024 182.454C97.0305 182.326 96.9606 182.198 96.8931 182.071L96.8349 182.193ZM110.325 206.409C110.403 206.489 110.481 206.57 110.56 206.65C110.531 206.6 110.502 206.549 110.473 206.498C110.434 206.428 110.395 206.358 110.357 206.288L110.325 206.409Z",
    fill: "url(#paint7_linear_336_53037)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.629 136.785C132.671 136.774 132.713 136.763 132.755 136.752C134.851 135.984 137.234 138.711 138.137 142.837C139.018 146.881 138.103 150.777 136.071 151.617C136.029 151.628 135.987 151.639 135.987 151.639C133.891 152.407 131.508 149.68 130.605 145.554C129.766 141.499 130.639 137.613 132.629 136.785Z",
    fill: "url(#paint8_radial_336_53037)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.178 124.275C182.22 124.264 182.262 124.253 182.304 124.242C184.4 123.474 186.783 126.201 187.685 130.327C188.567 134.371 187.652 138.268 185.62 139.107C185.578 139.118 185.535 139.129 185.535 139.129C183.439 139.897 181.057 137.17 180.154 133.044C179.273 129 180.177 125.062 182.178 124.275Z",
    fill: "url(#paint9_radial_336_53037)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.354 142.858L158.368 142.851L158.381 142.843C158.445 142.805 158.503 142.776 158.576 142.742L158.579 142.74C158.65 142.706 158.734 142.666 158.828 142.609L158.842 142.6L158.856 142.59C159.51 142.09 159.95 141.216 160.146 140.307C160.343 139.394 160.309 138.381 159.945 137.571L159.945 137.571L159.943 137.567C159.84 137.346 159.651 137.135 159.448 136.981C159.26 136.837 159.003 136.701 158.739 136.7C158.577 136.684 158.441 136.727 158.364 136.752C158.36 136.753 158.356 136.754 158.352 136.756L158.333 136.762L158.315 136.77C158.042 136.895 157.891 137.133 157.805 137.368C157.72 137.601 157.684 137.867 157.664 138.113L157.664 138.113L157.664 138.124C157.638 138.717 157.617 139.038 157.575 139.278C157.536 139.5 157.478 139.656 157.359 139.911L157.348 139.933L157.345 139.932C157.073 139.762 156.837 139.579 156.589 139.385C156.522 139.314 156.467 139.225 156.393 139.1C156.391 139.097 156.388 139.093 156.386 139.089C156.314 138.969 156.221 138.814 156.088 138.68C155.731 138.32 155.232 138.19 154.796 138.398L154.77 138.411L154.747 138.427L154.738 138.434C154.626 138.514 154.481 138.618 154.351 138.777L154.351 138.777L154.345 138.785C154.186 138.992 154.09 139.269 154.036 139.528C153.981 139.791 153.963 140.072 153.983 140.309L153.984 140.325L153.987 140.34C154.031 140.579 154.149 140.791 154.261 140.968C154.307 141.041 154.357 141.114 154.403 141.183C154.414 141.199 154.425 141.214 154.435 141.23C154.492 141.314 154.545 141.394 154.591 141.473L154.597 141.482L154.603 141.491C155.547 142.87 157.052 143.489 158.354 142.858Z",
    fill: "#954C08",
    stroke: "#934B06",
    strokeWidth: 0.645729
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_53037",
    x1: 95.0729,
    y1: 60.0039,
    x2: 147.075,
    y2: 215.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9B43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_53037",
    x1: 91.0301,
    y1: 202.455,
    x2: 33.2639,
    y2: 106.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303859,
    stopColor: "#F28A31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB544"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_53037",
    x1: 200.49,
    y1: 85.3015,
    x2: 165.189,
    y2: 192.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_336_53037",
    x1: 103.249,
    y1: 23.3955,
    x2: 117.162,
    y2: 93.3255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#2C9280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C9280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_336_53037",
    x1: 114.7,
    y1: 26.8114,
    x2: 126.889,
    y2: 88.0772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_336_53037",
    x1: 95.5028,
    y1: 25.0314,
    x2: 108.962,
    y2: 92.6788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD3BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_336_53037",
    x1: 112.823,
    y1: 85.1756,
    x2: 132.178,
    y2: 210.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_336_53037",
    x1: 177.421,
    y1: 227.995,
    x2: 61.3409,
    y2: 159.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1741A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F48015"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_336_53037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.371 144.195) rotate(75.2939) scale(7.62002 3.99999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964D08"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_336_53037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.92 131.686) rotate(75.2939) scale(7.62002 3.99999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A75C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#924905"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading4);
export default __webpack_public_path__ + "static/media/loading_4.ed4fb8c2bb1d35fa009ba4fbb8f96074.svg";
export { ForwardRef as ReactComponent };